import styled from '@emotion/styled'
import { Grid, Typography } from '@mui/material'
import * as api from "api"
import RatioElement from "common/ElementRatio"
import ResponsiveModelImage from "common/ResponsiveModelImage"
import { memo } from "react"
import Shared from "theme/shared"
import VehiclePerformanceGauges from "./VehiclePerformanceGauges"

const Styled = {
  Wrapper: styled.div`
    margin: 20px 0;
    text-align: center;
  `,
  Performance: styled.div`
    margin: 0 15px 10px;
  `,
  ImageWrap: styled.div`
    margin-left: -15px;
    margin-right: -15px;
  `,
  Title: styled(Typography)`
    font-size: 20px;
    font-weight: bold;
    color: ${(p) => p.theme.colors.marine};
  `,
  Description: styled(Typography)`
    margin: 5px 0 20px;
    font-size: 14px;
    font-weight: 500;
    color: ${(p) => p.theme.colors.bluishGrey};
  `,
  Grid: styled(Grid)`
    margin-top: 10px;
    gap: 50px;
  `,
}

type VehiclePerformancesMobileProps = {
  title: string
  data: api.VehiclePerformance[]
}

const VehiclePerformancesMobile = ({
  title,
  data,
}: VehiclePerformancesMobileProps) => {
  return (
    <Styled.Wrapper>
      <Shared.Header>{title}</Shared.Header>
      <Shared.Divider />
      {data.map((p, i) => (
        <Styled.Performance key={i}>
          <Styled.ImageWrap>
            <RatioElement ratio={1 / 1}>
              <ResponsiveModelImage image={p.image} />
            </RatioElement>
          </Styled.ImageWrap>
          <Styled.Title>{p.headline}</Styled.Title>
          <Styled.Description>{p.subtitle}</Styled.Description>
          <VehiclePerformanceGauges data={p} />
        </Styled.Performance>
      ))}
    </Styled.Wrapper>
  )
}

export default memo(VehiclePerformancesMobile)
